import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["_name", "images", "quantity"],
  _excluded2 = ["quantity"];
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { getProductPrice } from '~/utils/ProductPrice';
import { cloneDeep } from 'lodash-es';
import ATCRdpBody from '~/components/Layout/AddToCartRDP/components/ATCRdpBody.vue';
import AddToCart from '~/components/Layout/Cart/AddToCart/AddToCart.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useUser } from '~/composables/_next/useUser';
import { useWait } from '~/composables/_next/useWait';
import useAtc from '~/composables/recipe';
import { useCart } from '~/composables/useCart';
import { useCartGetters } from '~/composables/_next/cart/useCartGetters';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
import { generateVariantString } from '~/utils';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { centimesToEuros, gtmPriceFormat, cartDiscountPrice } from '~/helpers/gtm';
import { yieldToMain } from '~/utils/yieldToMain';
import { recipeIngredientsStore } from '~/store/RecipeIngredientsStore';
import { isProductOutOfStock } from '~/utils/ProductAvailability';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddToCartRDPOrganism',
  setup: function setup(__props) {
    var _useNuxt2App = useNuxt2App(),
      $sentry = _useNuxt2App.$sentry,
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale,
      currency = _useLocalization.currency;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useUiState = useUiState(),
      _toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useCart = useCart(),
      addItemsToCart = _useCart.addItemsById,
      addRecipe = _useCart.addRecipe,
      cart = _useCart.cart;
    var _useCartGetters = useCartGetters(),
      getItemPrice = _useCartGetters.getItemPrice;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useAddToCart = useAddToCart(),
      normalizeVariants = _useAddToCart.normalizeVariants;
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var modalRef = ref(null);
    var selectedProducts = ref([]);
    var modalDisplay = ref('ingredients');
    provide('selectedProducts', selectedProducts);
    var state = ref('ingredients');
    var equipment = toRef(recipeIngredientsStore, 'equipmentProducts');
    var ingredients = toRef(recipeIngredientsStore, 'ingredients');
    var capacityToCreate = inject('capacityToCreate');
    var ingredientsConfig = inject('ingredients');
    var quantity = inject('quantity');
    var id = inject('recipeID');
    var slug = inject('recipeSlug');
    var name = inject('recipeName');
    var image = inject('recipeImage');
    var parentFamily = inject('recipeParentFamily');
    var content = useAtc({
      equipment: equipment,
      ingredients: ingredients,
      capacityToCreate: capacityToCreate,
      ingredientsConfig: ingredientsConfig,
      quantity: quantity,
      state: state,
      slug: slug,
      id: id,
      name: name,
      image: image,
      parentFamily: parentFamily
    });
    provide('content', content);
    var toggleCartSidebar = function toggleCartSidebar() {
      _toggleCartSidebar();
      closeRDPAddToCartModal();
    };
    var allOutOfStock = computed(function () {
      return content.products.value.every(function (product) {
        return isProductOutOfStock(product);
      });
    });
    watch(modalDisplay, function (newDisplay) {
      if (newDisplay === 'ingredients') {
        selectedProducts.value = [];
      }
      if (newDisplay === 'confirm' && !isMobile.value) {
        closeRDPAddToCartModal();
        toggleCartSidebar();
      }
      if (!content.products.value.length || allOutOfStock.value) {
        setModalDisplay('confirm');
      }
    });
    var products = computed(function () {
      var _selectedProducts$val, _selectedProducts$val2;
      return (_selectedProducts$val = selectedProducts.value) === null || _selectedProducts$val === void 0 ? void 0 : (_selectedProducts$val2 = _selectedProducts$val.filter(function (product) {
        return product.isEquipment === content.hasEquipment.value;
      })) === null || _selectedProducts$val2 === void 0 ? void 0 : _selectedProducts$val2.map(function (_ref) {
        var title = _ref._name,
          _ref$images = _slicedToArray(_ref.images, 1),
          image = _ref$images[0],
          quantity = _ref.quantity,
          product = _objectWithoutProperties(_ref, _excluded);
        var price = cloneDeep(product.price);
        price.value.centAmount = price.value.centAmount * quantity;
        return {
          title: title,
          image: image.url,
          variant: generateVariantString(product, locale),
          price: price,
          quantity: quantity
        };
      });
    });
    var productsToBeAdded = ref([]);
    var total = computed(function () {
      return calculateTotalPrices(content.products.value);
    });

    /**
     * Closes the modal and reset its state.
     */
    function closeRDPAddToCartModal() {
      selectedProducts.value = [];
      modalDisplay.value = 'ingredients';
      content.state.value = 'ingredients';
      modalRef.value.modal.close();
    }

    /**
     * Sets the modal display.
     *
     * @param      {('confirm'|'equipments'|'ingredients')}  [display='ingredients']  The display
     */
    function setModalDisplay() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ingredients';
      modalDisplay.value = display;
    }

    /**
     * Calculates the total prices.
     *
     * @param      {Array}  products  The products
     * @return     {Object}  The total prices.
     */
    function calculateTotalPrices(products) {
      var totalRegular = 0;
      var totalSpecial = 0;
      var hasSpecialPrice = false;
      products.forEach(function (product) {
        var price = getProductPrice(product);
        totalRegular += price.regular * product.quantity;
        if (price.special) {
          totalSpecial += price.special * product.quantity;
        } else {
          totalSpecial += price.regular * product.quantity;
        }
      });
      if (totalRegular !== totalSpecial) {
        hasSpecialPrice = true;
      }
      totalRegular = parseFloat(totalRegular.toFixed(2));
      totalSpecial = parseFloat(totalSpecial.toFixed(2));
      return {
        regular: totalRegular,
        special: hasSpecialPrice ? totalSpecial : null
      };
    }

    /**
     * Adds to cart.
     *
     */
    function addToCart() {
      return _addToCart.apply(this, arguments);
    }
    /**
     * Sends analytics to Klaviyo and GTM.
     *
     */
    function _addToCart() {
      _addToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _products, clonedProducts, toAdd;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              startWaiter('add-to-cart');
              _context.prev = 1;
              _products = content.products.value.filter(function (product) {
                return product.quantity;
              });
              clonedProducts = Object.assign(_toConsumableArray(_products));
              selectedProducts.value = selectedProducts.value.concat(clonedProducts);
              toAdd = _products.map(function (_ref2) {
                var quantity = _ref2.quantity,
                  product = _objectWithoutProperties(_ref2, _excluded2);
                return {
                  product: normalizeVariants([product])[0],
                  quantity: quantity
                };
              });
              _context.next = 8;
              return yieldToMain();
            case 8:
              _context.next = 10;
              return addItemsToCart({
                productList: toAdd
              });
            case 10:
              if (!(modalDisplay.value === 'ingredients')) {
                _context.next = 19;
                break;
              }
              _context.next = 13;
              return yieldToMain();
            case 13:
              _context.next = 15;
              return addRecipe({
                id: content.id.value,
                slug: content.slug.value,
                name: content.name.value,
                image: content.image.value,
                parentFamily: content.parentFamily.value
              });
            case 15:
              setModalDisplay('equipments');
              content.state.value = 'equipments';
              _context.next = 20;
              break;
            case 19:
              if (modalDisplay.value === 'equipments') {
                setModalDisplay('confirm');
                content.state.value = 'confirm';
                toggleCartSidebar();
              }
            case 20:
              _context.next = 26;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
            case 26:
              _context.prev = 26;
              endWaiter('add-to-cart');
              return _context.finish(26);
            case 29:
              sendAnalytics(productsToBeAdded);
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 22, 26, 29]]);
      }));
      return _addToCart.apply(this, arguments);
    }
    function sendAnalytics(_x) {
      return _sendAnalytics.apply(this, arguments);
    }
    function _sendAnalytics() {
      _sendAnalytics = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(products) {
        var _user$value, _cart$value;
        var route, pageUrl, recipeItems, trackersRecipeItems, totalPrice, totalPriceInCents, totalQuantity, addedProperty, customerEmail, recipeName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              route = useRoute();
              pageUrl = route.fullPath;
              recipeItems = productsToBeAdded.value.map(function (_ref3) {
                var _product$price, _product$price$value, _product$price2, _product$price2$disco, _product$price2$disco2;
                var product = _ref3.product,
                  quantity = _ref3.quantity;
                return {
                  ProductId: product._id,
                  ProductSku: product.sku,
                  ItemPrice: centimesToEuros((_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$value = _product$price.value) === null || _product$price$value === void 0 ? void 0 : _product$price$value.centAmount),
                  ItemPriceDiscount: centimesToEuros((_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$disco = _product$price2.discount) === null || _product$price2$disco === void 0 ? void 0 : (_product$price2$disco2 = _product$price2$disco.value) === null || _product$price2$disco2 === void 0 ? void 0 : _product$price2$disco2.centAmount) || '',
                  ItemQuantity: quantity
                };
              });
              trackersRecipeItems = productsToBeAdded.value.map(function (_ref4) {
                var product = _ref4.product,
                  quantity = _ref4.quantity;
                var _getItemPrice = getItemPrice(product),
                  regular = _getItemPrice.regular,
                  special = _getItemPrice.special;
                var discountPrice = cartDiscountPrice({
                  regular: regular,
                  quantity: quantity
                }, special);
                return {
                  item_id: "SKU_".concat(product.sku),
                  item_sku: product.sku,
                  item_name: product._name,
                  discount: discountPrice ? gtmPriceFormat(discountPrice) : '',
                  discount_in_cents: discountPrice ? gtmPriceFormat(discountPrice, true) : '',
                  quantity: quantity,
                  price: centimesToEuros(product.price.value.centAmount),
                  price_in_cents: gtmPriceFormat(product.price.value.centAmount),
                  isMaster: product.isMaster,
                  currency: product.price.value.currencyCode,
                  item_location: 'recipe'
                };
              });
              totalPrice = trackersRecipeItems.reduce(function (sum, item) {
                return sum + item.price * item.quantity;
              }, 0);
              totalPriceInCents = trackersRecipeItems.reduce(function (sum, item) {
                return sum + item.price_in_cents * item.quantity;
              }, 0);
              totalQuantity = trackersRecipeItems.reduce(function (sum, item) {
                return sum + item.quantity;
              }, 0);
              addedProperty = {
                RecipeUrl: route.path,
                Price: totalPrice,
                items: recipeItems
              };
              customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
              if (!customerEmail) {
                _context2.next = 13;
                break;
              }
              _context2.next = 12;
              return yieldToMain();
            case 12:
              klaviyoClientPushEvent(customerEmail, locale, addedProperty, 'Recipe added to cart');
            case 13:
              _context2.next = 15;
              return yieldToMain();
            case 15:
              recipeName = computed(function () {
                var matches = route.path.match(/recipe\/([^\/\?]+)/);
                return matches && matches[1] ? matches[1] : null;
              });
              $trackers.gtm.trackAddToCart({
                title: recipeName.value,
                pageUrl: pageUrl,
                quantity: totalQuantity,
                items: trackersRecipeItems,
                value: totalPrice,
                currency: currency,
                cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
                value_in_cents: totalPriceInCents
              });
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _sendAnalytics.apply(this, arguments);
    }
    return {
      __sfc: true,
      $sentry: $sentry,
      $trackers: $trackers,
      locale: locale,
      currency: currency,
      client: client,
      _toggleCartSidebar: _toggleCartSidebar,
      isMobile: isMobile,
      addItemsToCart: addItemsToCart,
      addRecipe: addRecipe,
      cart: cart,
      getItemPrice: getItemPrice,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      normalizeVariants: normalizeVariants,
      user: user,
      isAuthenticated: isAuthenticated,
      modalRef: modalRef,
      selectedProducts: selectedProducts,
      modalDisplay: modalDisplay,
      state: state,
      equipment: equipment,
      ingredients: ingredients,
      capacityToCreate: capacityToCreate,
      ingredientsConfig: ingredientsConfig,
      quantity: quantity,
      id: id,
      slug: slug,
      name: name,
      image: image,
      parentFamily: parentFamily,
      content: content,
      toggleCartSidebar: toggleCartSidebar,
      allOutOfStock: allOutOfStock,
      products: products,
      productsToBeAdded: productsToBeAdded,
      total: total,
      closeRDPAddToCartModal: closeRDPAddToCartModal,
      setModalDisplay: setModalDisplay,
      calculateTotalPrices: calculateTotalPrices,
      addToCart: addToCart,
      sendAnalytics: sendAnalytics,
      getProductPrice: getProductPrice,
      ATCRdpBody: ATCRdpBody,
      AddToCart: AddToCart,
      AzLoader: AzLoader,
      AzModal: AzModal,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzImg: AzImg,
      PriceDisplay: PriceDisplay
    };
  }
});